// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MailTwoToneSvg from "@fishx/icons-svg/es/asn/MailTwoTone";
import FishxIcon from '../components/FishxIcon';

var MailTwoTone = function MailTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: MailTwoToneSvg
  }));
};

MailTwoTone.displayName = 'MailTwoTone';
export default React.forwardRef(MailTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/MailTwoTone.js
// module id = 3083
// module chunks = 0